import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';

import { mapViewSettings } from './mapViewSettings';

const getNetworkEventsRoutesFO = ({ currentUser }) => ({
  filters_status_events_path: () =>
    Routes.filters_status_user_events_path(currentUser.id),
  events_path: (params) => Routes.user_events_path(currentUser.id, params),
  markers_path: (params) => Routes.markers_v2_events_path(params),
});

const getNetworkEventsRoutesPO = () => ({
  filters_status_events_path: () => Routes.filters_status_po_events_path(),
  events_path: (params) => Routes.network_events_path(params),
  markers_path: (params) => Routes.markers_v2_po_events_path(params),
});

const getTopicEventsRoutesFO = ({ topicId }) => ({
  filters_status_events_path: () =>
    Routes.filters_status_topics_topic_events_path(topicId),
  events_path: (params) => Routes.topics_topic_events_path(topicId, params),

  markers_path: (params) =>
    Routes.markers_v2_topics_topic_events_path(topicId, params),
});

const getTopicEventsRoutesPO = ({ topicId, topicContext }) => ({
  filters_status_events_path: () =>
    dynamicTopicResourcePath(
      Routes.topic_publicoffice_topics_events_filters_status_path(topicId),
      topicContext,
    ),
  events_path: (params) =>
    dynamicTopicResourcePath(
      Routes.topic_publicoffice_topics_events_path(topicId, params),
      topicContext,
    ),
  markers_path: (params) =>
    dynamicTopicResourcePath(
      Routes.topic_publicoffice_topics_events_markers_v2_path(topicId, params),
      topicContext,
    ),
});

const getRoutes = (type, params) => {
  const { currentUser } = params;

  switch (type) {
    case 'group': {
      return currentUser
        ? getTopicEventsRoutesFO(params)
        : getTopicEventsRoutesPO(params);
    }
    default: {
      return currentUser
        ? getNetworkEventsRoutesFO(params)
        : getNetworkEventsRoutesPO();
    }
  }
};

const getEventsIndexConfig = (type, params, appPageConfig) => {
  const { topicId, currentUser, featuresConfig } = params;
  const routes = getRoutes(type, params);

  return {
    topicId,
    routes: {
      user_event_path: (userId, eventId) =>
        Routes.user_event_path(userId, eventId),
      ...routes,
    },
    enableEventCalendarView:
      featuresConfig?.events?.config?.enable_event_calendar_view,
    mapViewSettings: mapViewSettings({
      configs: featuresConfig?.events?.config,
      currentUser,
    }),
    appPageConfig,
  };
};

export default getEventsIndexConfig;
